<div class="container card fixed-min">
  <!-- HEADER -->
  <div class="card-title">
    <div class="row align-items-center">
      <div class="col-8 my-0">
        <div class="d-flex align-items-center mx-2 mt-2">
          <h2>Filtros:</h2>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 mt-2">
        <div class="d-flex align-items-end justify-content-end mx-3"></div>
      </div>
    </div>
  </div>

  <hr class="my-0" />

  <!-- BODY -->
  <div class="card-body">
    <!-- ROW FECHAS -->
    <div class="row">
      <!-- DESDE -->
      <div class="col-lg col-sm-12">
        <div class="row">
          <label
            for="fromDatePicker"
            class="form-label title-blue-bimbo-cap mx-2">
            Desde:
            {{
              getStartDateSelected
                | date: "EEEE dd-MMMM-yyyy" : "" : "es-mx"
                | titlecase
            }}
          </label>

          <div class="input-group">
            <input
              class="form-control"
              placeholder="yyyy-mm-dd"
              ngbDatepicker
              [(ngModel)]="startDate"
              id="fromDatePicker"
              #d1="ngbDatepicker" />

            <button mat-icon-button type="button" (click)="d1.toggle()">
              <mat-icon>calendar_today</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <!-- HASTA -->
      <div class="col-lg col-sm-12">
        <div class="row">
          <label
            for="toDate"
            class="form-label title-blue-bimbo-cap mt-lg-0 mt-sm-1 mx-2">
            Hasta:
            {{
              getEndDateSelected
                | date: "EEEE dd-MMMM-yyyy" : "" : "es-mx"
                | titlecase
            }}
          </label>

          <div class="input-group">
            <input
              class="form-control"
              placeholder="yyyy-mm-dd"
              ngbDatepicker
              [(ngModel)]="endDate"
              id="toDate"
              #d2="ngbDatepicker" />

            <button mat-icon-button type="button" (click)="d2.toggle()">
              <mat-icon>calendar_today</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <!-- BOTON BUSCAR -->
      <div
        class="col-lg-1 col-sm-12 row align-items-center justify-content-center mt-2"
        style="min-width: 49px">
        <button mat-mini-fab color="primary" (click)="emitFilters()">
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </div>
    <div class="row col-12">
      <span class="form-text text-danger" *ngIf="getShowDatesError">
        Por favor, asegúrese de ingresar ambas fechas y que la fecha de inicio
        sea anterior a la fecha de fin.
      </span>
      <div *ngIf="isLoading" class="d-flex justify-content-center">
        <span class="spinner-border spinner-border-sm mt-3" role="status">
        </span>
      </div>

      <!-- Input -->
      <div id="filters-div" *ngIf="!isLoading">
        <div class="row mb-3 align-content-center">
          <div class="col-10 mt-3">
            <label class="form-label title-blue-bimbo-cap mx-2">
              Buscar Sesión:
            </label>

            <input
              type="text"
              class="form-control"
              [(ngModel)]="textSearch"
              (keyup.enter)="onSearchSubmit()"
              (blur)="onSearchSubmit()"
              placeholder="Buscar por nombre de la sesión o ID localizador" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
